import React, { createContext, use, useState } from 'react'

import useDidMount from '@divvy-web/hooks.usedidmount'

import TimeoutPromptModal from './TimeoutPromptModal/TimeoutPromptModal'

interface TimeoutPromptContextValue {
  updateProcessor: (() => void) | null
  setUpdateProcessor: (updated: (() => void) | null) => void
}

const TimeoutPromptContext = createContext<TimeoutPromptContextValue>({
  updateProcessor: () => {},
  setUpdateProcessor: () => {},
})

const TimeoutPromptProvider = ({ children }: React.PropsWithChildren) => {
  const [updateProcessor, setUpdateProcessor] = useState<(() => void) | null>(null)

  return (
    <TimeoutPromptContext
      value={{
        updateProcessor,
        setUpdateProcessor,
      }}
    >
      <TimeoutPromptModal formSubmit={updateProcessor} />
      {children}
    </TimeoutPromptContext>
  )
}

interface UseTimeoutPromptUpdaterParams {
  updateProcessor?: () => void
}

export const useTimeoutPromptUpdater = ({ updateProcessor }: UseTimeoutPromptUpdaterParams) => {
  const context = use(TimeoutPromptContext)

  if (!context) {
    throw new Error('cannot use useTimePrompt outside of TimeoutPromptContext')
  }

  const { setUpdateProcessor } = context

  useDidMount(() => {
    if (updateProcessor) {
      setUpdateProcessor(() => updateProcessor)
    }

    return () => {
      setUpdateProcessor(null)
    }
  })
}

export default TimeoutPromptProvider
